<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">
      {{ 'reminder-send.title' | translate }}
      <span class="ml-auto" *ngIf="client">{{ client.name }}</span>
    </h4>
  </div>
  <div class="modal-body pb-0">
    <form class="row" novalidate (ngSubmit)="onSave()" [formGroup]="form">
      <div class="col">
        <div class="form-group row">
          <label for="email" class="col-sm-4 col-form-label"
            >{{ 'reminder-send.email.label' | translate }}:</label
          >
          <div class="col-sm-8">
            <input
              type="text"
              class="form-control data-hj-whitelist"
              id="email"
              name="email"
              formControlName="email"
              [class.is-invalid]="
                sent && form.get('email').hasError('required')
              "
            />

            <div
              class="invalid-feedback animate-show animate-fast"
              *ngIf="sent && form.get('email').hasError('required')"
            >
              {{ 'global.validators.required.error' | translate }}
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="row">
      <div class="col px-0">
        <p class="px-3">{{ 'reminder-send.documents.title' | translate }}:</p>

        <table
          class="table mb-0"
          *ngIf="documents$ | async as documents; else loading"
        >
          <tr>
            <td>{{ 'reminder-send.documents.number' | translate }}</td>
            <td>{{ 'reminder-send.documents.due-date' | translate }}</td>
            <td class="text-right">
              {{ 'reminder-send.documents.due-amount' | translate }}
            </td>
          </tr>
          <tr *ngFor="let document of documents">
            <td>{{ document.number }}</td>
            <td>{{ document.dateDue | pepDate: org.locale }}</td>
            <td class="text-right">
              {{
                document.totalDue | pepCurrency: document.currencyId:org.locale
              }}
            </td>
          </tr>
          <tr class="font-weight-bold">
            <td colspan="2">
              {{ 'reminder-send.documents.total' | translate }}:
            </td>
            <td class="text-right">
              <ng-container *ngFor="let t of totals"
                >{{ t.amount | pepCurrency: t.currencyId:org.locale }}<br />
              </ng-container>
            </td>
          </tr>
        </table>

        <ng-template #loading>
          <app-content-loader loading="true"></app-content-loader>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="onClose()">
      {{ 'Cancel' | translate }}
    </button>
    <button class="btn btn-primary" type="button" (click)="onSave()">
      {{ 'Send' | translate }}
      <!-- <ng-template #loading
        >&nbsp; <i class="fa fa-spinner-third fa-spin fa-md fa-lg"></i
      ></ng-template> -->
    </button>
  </div>
</div>
